import { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';

export const useSocket = (companyId, pageId, callBackFunc) => {
  const [isConnected, setIsConnected] = useState(false);
  const socketRef = useRef(null);

  useEffect(() => {
    if (companyId && pageId) {
      socketRef.current = io(import.meta.env.VITE_API_PATH.replace('/v1', ''), {
        query: { companyId, pageId },
        transports: ['websocket'],
      });

      const socket = socketRef.current;

      socket.on('connect', () => {
        setIsConnected(true);
        console.log('Connected to socket room:', `room:${companyId}_${pageId}`);
      });

      socket.on('update-analytics-data', (payload) => {
        callBackFunc(payload);
      });

      socket.on('disconnect', () => {
        setIsConnected(false);
      });

      return () => {
        socket.disconnect();
      };
    }
  }, [companyId, pageId]); // Re-run if IDs change (e.g., user switches pages)

  return { isConnected };
};
